import { ChannelChip } from './ChannelChip';

/**
 * Channel chip for "synthetic" channels — videos uploaded by a user
 * without a publishing channel. Renders with a stub avatar and
 * subscribe disabled.
 */
export interface SyntheticChannelChipProps {
  uploaderName: string;
  uploaderId?: string;
}

export function SyntheticChannelChip({ uploaderName, uploaderId }: SyntheticChannelChipProps) {
  return (
    <ChannelChip
      channelSlug={uploaderId ?? uploaderName.toLowerCase().replace(/\s+/g, '-')}
      channelName={uploaderName}
      showSubscribe={false}
    />
  );
}
